import { Component, ViewChild } from '@angular/core';
import { QrisListTableComponent } from './components/qris-list-table/qris-list-table.component';

@Component({
  standalone: false,
  selector: 'app-qrisly',
  templateUrl: './qrisly.component.html',
  styleUrl: './qrisly.component.scss'
})
export class QrislyComponent {
  loading: boolean = true;

  @ViewChild(QrisListTableComponent) table!: QrisListTableComponent;

  constructor() {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }

  handleAfterUpload(): void {
    this.table.getList();
  }
}
